import React from "react";
import "./OrderTiming.css";

const VALID_TONES = new Set(["green", "orange", "red", "neutral"]);

const OrderTiming = ({ timing, showDescription = true } = {}) => {
  const tone = VALID_TONES.has(timing?.tone) ? timing.tone : "neutral";
  const label = timing?.label || "Timer unavailable";
  const display = timing?.display || "—";
  const description = timing?.description || "Timing information is not available.";
  const prepMinutes = Number.isFinite(timing?.prepMinutes) ? timing.prepMinutes : null;

  return (
    <section
      className={`kds-order-timing kds-order-timing--${tone}`}
      aria-label="Order timing"
      aria-live="off"
    >
      <div className="kds-order-timing__copy">
        <span className="kds-order-timing__label">{label}</span>
        {showDescription && <span className="kds-order-timing__description">{description}</span>}
      </div>
      <div className="kds-order-timing__readout">
        <span className="kds-order-timing__value" aria-label={`${label}: ${display}`}>
          {display}
        </span>
        {prepMinutes !== null && (
          <span className="kds-order-timing__prep">
            Prep estimate <strong>{prepMinutes} min</strong>
          </span>
        )}
      </div>
    </section>
  );
};

export default OrderTiming;
